import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const initKingCollectionSlider = (element) => {
  return new Swiper(element, {
    modules: [Navigation],
    slidesPerView: 3.6,
    spaceBetween: 30,
    loop: true,
    navigation: {
      prevEl: '.js-kings-collections-slider__button--prev',
      nextEl: '.js-kings-collections-slider__button--next',
      enabled: true
    },
    breakpoints: {
      280: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2.6
      },
      1300: {
        slidesPerView: 3.6
      }
    }
  });
};

const kingsCollectionSlider = [...document.querySelectorAll('.js-kings-collections-slider')];

kingsCollectionSlider.map(element => initKingCollectionSlider(element));